// problems#stats — server-rendered page; the two SVG charts are drawn here
// from the embedded JSON (see problem_stats.ts).
import { registerPage } from "../first"
import { mountProblemStats } from "../problem_stats"

export const ProblemsStatsPage = {
  onDomReady(): void {
    mountProblemStats()
  },
}

registerPage("ProblemsStatsPage", ProblemsStatsPage)
